import { render, staticRenderFns } from "./SpentGain.vue?vue&type=template&id=032d50ba&scoped=true&"
import script from "./SpentGain.vue?vue&type=script&lang=js&"
export * from "./SpentGain.vue?vue&type=script&lang=js&"
import style0 from "./SpentGain.vue?vue&type=style&index=0&id=032d50ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d50ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VSelect})
